var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 17.8,
    cy: 17.8,
    r: 16.8,
    stroke: "#DBDED4",
    strokeWidth: 0.843243
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons/large/mir_contact"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Office/Contact"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5985 9.00008L13.9888 9.00013C15.2937 8.98741 16.406 9.944 16.5899 11.2454C16.6814 11.9387 16.8509 12.6194 17.0946 13.2723L17.1547 13.4518C17.4212 14.355 17.1784 15.3389 16.5056 16.0193L16.047 16.4781L16.2918 16.8379C17.1331 18.0215 18.1866 19.0407 19.3996 19.843L19.433 19.8631L19.8954 19.4011C20.572 18.732 21.5557 18.4894 22.4571 18.7553L23.0322 18.9529C23.5644 19.1245 24.1124 19.2478 24.6742 19.322C25.9814 19.5064 26.9429 20.6412 26.9105 21.9362L26.9105 24.3321C26.9135 25.0642 26.6077 25.7636 26.0682 26.2585C25.5287 26.7534 24.8056 26.998 24.0585 26.9303C21.4413 26.6459 18.9272 25.7516 16.7262 24.3242C14.6693 23.0172 12.9255 21.2733 11.6232 19.2239C10.1858 17.005 9.29127 14.4787 9.01056 11.8342C8.94488 11.1073 9.18771 10.3863 9.67976 9.84726C10.1718 9.30829 10.8676 9.00089 11.5985 9.00008ZM14.0084 11L11.5997 11.0001C11.4312 11.0003 11.2706 11.0712 11.157 11.1956C11.0434 11.32 10.9874 11.4864 11.001 11.6386C11.247 13.9552 12.0353 16.1812 13.3066 18.1438C14.4562 19.9529 15.9899 21.4866 17.8067 22.6411C19.7531 23.9033 21.9684 24.6914 24.2566 24.9402C24.4249 24.9554 24.5918 24.899 24.7163 24.7848C24.8407 24.6706 24.9113 24.5092 24.9106 24.3362L24.9109 21.9114C24.9185 21.6068 24.6966 21.3449 24.4039 21.3036C23.561 21.1924 22.7335 20.9863 21.9348 20.6882C21.7155 20.6058 21.4683 20.6585 21.3057 20.8193L20.2897 21.8353C19.9714 22.1536 19.4797 22.22 19.0883 21.9974C16.929 20.7696 15.1411 18.9818 13.9133 16.8224C13.6908 16.4311 13.7572 15.9394 14.0755 15.621L15.0876 14.609C15.2523 14.4425 15.305 14.1953 15.2217 13.9738C14.9245 13.1773 14.7184 12.3497 14.6085 11.5161C14.5663 11.2179 14.3096 10.9971 14.0084 11Z",
    fill: "#8CAEB4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundPhone);
export default __webpack_public_path__ + "static/media/round-phone.8c957356e00588dff093c999ea37b98e.svg";
export { ForwardRef as ReactComponent };